import { Injectable } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  private stripePromise: Promise<Stripe | null> | null = null;
  private mobileReturnHandlerRegistered = false;

  getStripe(): Promise<Stripe | null> {
    if (!this.stripePromise) {
      this.stripePromise = loadStripe(environment.stripe.publishableKey);
    }
    return this.stripePromise;
  }

  /**
   * Register handler for Stripe redirect-based payment returns (e.g. Bancontact) on native iOS/Android.
   * When the app is opened via the payment return_url, Stripe.handleURLCallback completes the flow.
   * Call once at app startup (e.g. from AppComponent).
   */
  registerMobilePaymentReturnHandler(): void {
    if (!Capacitor.isNativePlatform() || this.mobileReturnHandlerRegistered) {
      return;
    }
    this.mobileReturnHandlerRegistered = true;
    App.addListener('appUrlOpen', (event) => {
      const url = event.url;
      if (!url) return;
      this.getStripe().then((stripe) => {
        const stripeWithCallback = stripe as Stripe & { handleURLCallback?: (opts: { url: string }) => void };
        if (stripeWithCallback?.handleURLCallback) {
          stripeWithCallback.handleURLCallback({ url });
        }
      });
    });
  }
}
